import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VThemeProvider,{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-img',{staticStyle:{"padding":"40px","background-color":"white"},attrs:{"src":require('@/assets/logo-fondIndePresse.svg'),"contain":"","max-width":"250","min-height":"78","width":"100%"}}),_c('base-title',{attrs:{"size":"body-1","space":"4","title":"","weight":"regular"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }